import { render } from "./VaChart.vue?vue&type=template&id=7fcfead2"
import script from "./VaChart.vue?vue&type=script&lang=js"
export * from "./VaChart.vue?vue&type=script&lang=js"

import "./VaChart.vue?vue&type=style&index=0&id=7fcfead2&lang=scss"
script.render = render

export default script